import { MasterCard, MasterpassOTPTypes, PaymentMethod } from '../../../buy/services/payment-method.model';
import GlobalSpinnerService from '../../../common/services/spinner/global-spinner.service';
import NoAuthService from '../../services/noauth.service';
import UtilService from "../../../common/services/util.service";
import { MobileContractDto } from '../../../common/services/user/eula.model';
import { Invoice } from '../../../buy/services/invoice.model';
import { ListeningPackageType, PackageThumbnail } from '../../../common/services/package/package.model';
import GoogleAnalyticsService from '../../../common/services/analytics/google-analytics.service';
import { IFormController, IPromise, ITimeoutService } from 'angular';
import { Card } from '../../../buy/services/card.model';
import { OpenCardAddContractAction } from '../../../buy/card-add-contract-dialog/card-add-contract-dialog.action';
import { CardDeleteAction } from '../../../buy/card-delete-dialog/card-delete-dialog.action';
import { CardDeleteSuccessAction } from '../../../buy/card-delete-success-dialog/card-delete-success-dialog.action';
import { ChangePaymentInfoAction } from '../../../buy/change-payment-info-dialog/change-payment-info.action';
import { OpenMasterpassCardAddOtpAction } from '../../../buy/masterpass-card-add-otp-dialog/masterpass-card-add-otp-dialog.action';
import { OpenMasterpassCardLinkAction } from '../../../buy/masterpass-card-link-dialog/masterpass-card-link-dialog.action';
import { OpenMasterpassInfoAction } from '../../../buy/masterpass-info-dialog/masterpass-info-dialog.action';
import { PaycellService } from '../../../buy/services/paycell.service';
import ActionDispatcherService from '../../../common/actions/core/action-dispatcher.service';
import { DistantSaleAction } from '../../../common/actions/distant-sale-action';
import { PayByBillAction } from '../../../common/actions/pay-by-bill.action';
import { PayByPaycellAction } from '../../../common/actions/pay-by-paycell.action';
import { PreInfoSaleAction } from '../../../common/actions/pre-info-action';
import { NewCreditCardEvent } from '../../../common/services/analytics/events/dimensions';
import { MasterPassError } from '../../../common/services/error/error.action';
import HttpService from '../../../common/services/http.service';
import NotificationService from '../../../common/services/notification/notification.service';
import { NoAuthPayByMasterpassAction } from '../actions/masterpass.action';
import { NoAuthBillInfoAddAction } from '../bill-info-add/bill-info-add.action';
import { NoAuthBillInfoChangeAction } from '../actions/bill-info-change.action';
import MixpanelService from '../../../common/services/analytics/mixpanel.service';


/* @ngInject */
export default class PaymentMethodController {

  public cards: PaymentMethod[] = [];
  public cardType: string;
  public activeCard: PaymentMethod;
  public cardx: PaymentMethod;
  public selectedMethod: string;
  public isinValid: boolean = false;
  public masterCards: MasterCard[] = [];
  public referenceNo: number;
  public activeMasterCard: MasterCard;
  public mastercardx: MasterCard;
  public packet: PackageThumbnail;
  public approveSaveCard: boolean = false;
  public subscription: PackageThumbnail;
  public showCardSaveForm: boolean = false;
  public isPaymentMethodOpen: boolean = false;
  private paymentSectionInitialized: boolean = false;
  private openedForInitialCardLoad: boolean = false;

  mobileContractDto: MobileContractDto;
  eulaTextUrl: any;

  private invoice: Invoice;
  private cardAddFormDescription: string;
  private msisdn;
  private logoMap: any;
  private msisdnTr: string;
  private linkCardMode = false;
  private continueLinkCardMessage: string;
  private masterTokenRefreshCount: number = 0;
  private otpStatus: MasterpassOTPTypes = MasterpassOTPTypes.ADD_CARD;
  private sessionId: string;
  private token: string;
  private alias: string;
  private card: Card;
  private aggreement: boolean = false;
  private callAAfterD: boolean = false;
  private onStopTimer: any;
  private stopOtpReqSent: any;
  private mobileAggreement: boolean = false;
  private cardAddForm: IFormController;
  private bill: string;
  private payment: boolean;
  private tcellSubscriber: boolean;
  private tcellSubscriberCalled = false;
  private promocode: string;
  private years: string[] = [];


  constructor(
    private $scope,
    private $rootScope,
    private noAuthService: NoAuthService,
    private globalSpinner: GlobalSpinnerService,
    private notificationService: NotificationService,
    private paycellService: PaycellService,
    private $translate,
    private actionDispatcher: ActionDispatcherService,
    private config,
    private $sce,
    private $window,
    private i18n,
    private $timeout: ITimeoutService,
    private googleAnalytics: GoogleAnalyticsService,
    private $sanitize,
    private httpService: HttpService,
    private mixpanelService: MixpanelService
  ) { }

  public $onInit() {
    if (angular.isUndefined(this.packet) || angular.isUndefined(this.msisdn)) {
      return;
    }

    this.loadTranslations();
    this.globalSpinner.startIfNotActivated();
    this.loadCards();

    var _self = this;

    this.$rootScope.$on("$translateChangeSuccess", function (event, a) {
      _self.loadTranslations();
    });
    window['MFS'].setClientId(this.config.masterpass.clientId);
    if (!!this.config.masterpass.address) {
      window['MFS'].setAddress(this.config.masterpass.address);
    }
    this.logoMap = this.config.masterpass.logoMap;

    this.msisdnTr = '90' + this.msisdn;
    this.checkMasterPass();

    var currYear = new Date().getFullYear();
    this.years.push(currYear.toString().substring(2));
    for (var i = 0; i < 15; i++) {
      currYear += 1;
      this.years.push(currYear.toString().substring(2));
    }

    this.sessionId = localStorage.getItem('cardSessionId');
    this.token = localStorage.getItem('cardToken');
    this.alias = localStorage.getItem('cardAlias');

    this.globalSpinner.startIfNotActivated();
    if (this.sessionId && this.token) {
      localStorage.removeItem('cardSessionId');
      localStorage.removeItem('cardToken');
      localStorage.removeItem('cardAlias');
      localStorage.removeItem('changePayment');
      localStorage.removeItem('subscriptionId');
      this.noAuthService
        .createPaymentMethod(
          this.msisdn,
          this.sessionId,
          this.token,
          this.alias ? this.alias : ''
        )
        .then(data => {
          this.actionDispatcher.dispatch(new PayByPaycellAction(!parseInt(data) ? null : parseInt(data), data));
          this.googleAnalytics.trackEvent(angular.extend(JSON.parse(JSON.stringify(new NewCreditCardEvent)), { userPackage: localStorage.getItem('activePackages') }));
        }).catch(error => {
          this.googleAnalytics.trackEvent(angular.extend(JSON.parse(JSON.stringify(new NewCreditCardEvent)), { userPackage: localStorage.getItem('activePackages'), eventLabel: 'Failure', errorType: error.message || 'An error occured' }));
          this.googleAnalytics.sendGAEvent('Failure', this.packet, error, this.selectedMethod);
        });
    }
    this.globalSpinner.stop()
  }

  public findCardsByPaymentMethodId(paymentMethodId: number, cardId: string): IPromise<PaymentMethod> {
    return this.noAuthService.getCreditCardList(this.msisdn).then(cards => {
      this.activeCard = cards.filter(card => card.paymentMethodID === paymentMethodId || card.cardId === cardId)[0];
      return angular.copy(this.activeCard);
    });
  }

  private loadCards() {
    this.noAuthService
      .getCreditCardList(this.msisdn)
      .then(cards => {
        if (this.cardType != 'masterpass') {
          this.cards = cards;
          if (this.cards) {
            this.cards = this.cards.sort((a, b) => (a.isDefault === b.isDefault) ? 0 : a.isDefault ? -1 : 1)
          }
          this.activeCard = UtilService.getElements(this.cards, data =>
            this.comparator(data)
          )[0];

          if (angular.isUndefined(this.activeCard)) {
            this.activeCard = this.cards[0];
          }
        }
      })
      .catch((/*error*/) => (this.cards = []))
      .finally(() => {
        if (this.cardx) {
          this.cards = this.cards.filter(card => this.cardx.paymentMethodID !== card.paymentMethodID || this.cardx.cardId !== card.cardId);
          if (this.cards.length > 0) {
            this.activeCard = this.cards[0];
          }
        }
        this.definePaymentSection();
        if (this.selectedMethod === 'creditCard') {
          this.isinValid = true;
        }
      });
  }

  public loadTranslations() {
    this.$translate(' payment.addCard.securityDesc').then(value => {
      this.cardAddFormDescription = this.$sce.trustAsHtml(value);
    });
    this.listenProvisions();
  }

  public $postLink() {
    this.listenProvisions();
    angular.element(() => {
      this.cardAddForm = this.$scope.cardAddForm;
    });
  }

  private listenProvisions() {
    this.$timeout(() => {
      const provisions = angular.element('.provisions');
      if (provisions) {
        provisions.on('click', () => {
          this.onAddNewCardContract();
        })
      }
    });
  }

  public togglePaymentMethod() {
    this.isPaymentMethodOpen = !this.isPaymentMethodOpen;
  }

  public onChangeActiveCard(card: PaymentMethod) {
    this.activeCard = card;
  }

  public onChangeMasterpassActiveCard(card: MasterCard) {
    this.activeMasterCard = card;
  }

  private getPaymentType() {
    let type = 'creditCard';
    if (this.selectedMethod === 'bill') {
      type = 'bill';
    }
    return type;
  }

  public onDistantSale() {
    this.actionDispatcher.dispatch(new DistantSaleAction('distant_sales_form', this.getPaymentType()));
  }

  public onPreInfo() {
    this.actionDispatcher.dispatch(new PreInfoSaleAction('pre_info_contract', this.getPaymentType()));
  }

  public onPreInfoMobile() {
    this.actionDispatcher.dispatch(new PreInfoSaleAction('pre_info_contract', 'mobile'));
  }

  public onAddNewCardContract() {
    this.actionDispatcher.dispatch(
      new OpenCardAddContractAction(() => this.onAddCardContract())
    );
  }

  private definePaymentSection() {
    if (!this.paymentSectionInitialized && (this.payment || this.cardx)) {
      this.isPaymentMethodOpen = true;
    }

    if (this.selectedMethod != 'masterPassLinkCard') {
      if (this.masterCards.length) {
        this.selectedMethod = 'savedMasterCard0';
        if (this.openedForInitialCardLoad) {
          this.isPaymentMethodOpen = false;
          this.openedForInitialCardLoad = false;
        }
      } else if (this.cards.length) {
        this.selectedMethod = 'savedCard0';
      } else if (this.cardType === 'paycell' && this.cards && this.cards.length == 0) {
        this.selectedMethod = 'creditCard';
        if (!this.paymentSectionInitialized) {
          this.isPaymentMethodOpen = true;
        }
      } else {
        this.selectedMethod = 'masterPassAddCard';
        if (!this.paymentSectionInitialized) {
          this.isPaymentMethodOpen = true;
          this.openedForInitialCardLoad = true;
        }
      }
    }
    this.paymentSectionInitialized = true;
    this.isValidMethod();
    this.checkMobileContractStatus();
  }

  private onAddCardContract() {
    this.approveSaveCard = true;
  }

  private onAddCard() {
    this.globalSpinner.startIfNotActivated();
    this.card.ccNo = this.$sanitize(this.card.ccNo);
    this.card.cvcNo = this.$sanitize(this.card.cvcNo);
    this.card.alias = UtilService.decodeHtmlCharCodes(this.$sanitize(this.card.alias));
    this.card.expDateMonth = this.$sanitize(this.card.expDateMonth);
    this.card.expDateYear = this.$sanitize(this.card.expDateYear);
    this.card.ccNo = this.card.ccNo.replace(/-/gi, '');
    this.noAuthService.paymentHashData()
      .then(data => {
        this.paycellService
          .paymentRestToken(this.card, data)
          .then(data => {
            let token = data.cardToken;
            let threeDSession: IPromise<string>;
            if (this.cardx || this.payment || (this.subscription && (this.subscription.type === ListeningPackageType.SDP || this.subscription.type === ListeningPackageType.MOBILODEME))) {
              // sdp sadece faturama yansit ile alinabilen bir paket türüdür. Yeni kart ile alışveriş yapmak istendiğinde ve packet type SDP ise changePaymentREquest davranışı sergiler.
              // change Payment Method with new credit card
              threeDSession = this.noAuthService.get3DSessionIDForChangePayment(this.msisdn, token == null ? '' : token, this.subscription);
            } else {
              threeDSession = this.noAuthService.get3DSessionID(this.msisdn, token == null ? '' : token, this.packet.id);
            }
            threeDSession
              .then(data => {
                let sessionId = data;
                this.noAuthService.get3DSessionResult(this.msisdn, sessionId).then(data => {
                  const redirectUrl = window.location.href;
                  this.paycellService
                    .threeDSecure(sessionId, encodeURIComponent(redirectUrl))
                    .then(data => {
                      localStorage.setItem('cardToken', token);
                      localStorage.setItem('cardSessionId', sessionId);
                      if (this.card.alias) {
                        localStorage.setItem('cardAlias', this.card.alias);
                      }
                      if (this.cardx || this.payment || (this.subscription && (this.subscription.type === ListeningPackageType.SDP || this.subscription.type === ListeningPackageType.MOBILODEME))) {
                        localStorage.setItem('changePayment', '1');
                        localStorage.setItem('subscriptionId', this.subscription.id)
                      }
                      document.open();
                      document.write(data);
                      document.close();
                    })
                });
              })
          })
          .finally(() => this.globalSpinner.stop());
      }).catch(() => this.globalSpinner.stop());

  }

  private payDirect() {
    this.actionDispatcher.dispatch(
      new PayByPaycellAction(this.activeCard.paymentMethodID, this.activeCard.cardId)
    );
    return;
  }

  public onDeleteCard(card: PaymentMethod) {
    this.activeCard = card;
    this.actionDispatcher.dispatch(
      new CardDeleteAction(
        paymentMethodID => this.onDeleteSuccess(paymentMethodID, card.cardId),
        this.activeCard
      )
    );
  }

  private onDeleteSuccess(paymentMethodID: number, cardId: string): any {
    this.actionDispatcher.dispatch(new CardDeleteSuccessAction());
    this.cards = this.cards.filter(
      card => card.paymentMethodID != paymentMethodID || card.cardId != cardId
    );
    this.activeCard = this.cards[0];
  }

  public onConfirm(data: any) {
    this.aggreement = data.aggreement;
  }

  public onMobileConfirm(data: any) {
    this.mobileAggreement = data.mobileAggreement;
  }

  private startPayment(payWith3D: boolean = false) {
    this.globalSpinner.startIfNotActivated();
    if (payWith3D) {
      this.onAddCard(); // secure payment if card is new
    } else {
      this.payDirect();
    }
  }

  public onNext() {
    if (!this.aggreement && (this.selectedMethod === 'creditCard' && !this.approveSaveCard)) {
      this.notificationService.showNoAggrementMessage();
      this.notificationService.showCreditCardSaveNotSelectedMessage();
      return;
    }

    if (!this.aggreement) {
      this.notificationService.showNoAggrementMessage();
      return;
    }

    if (this.selectedMethod === 'bill' && this.mobileContractDto.showContract && !this.mobileAggreement) {
      this.notificationService.showNoMobilePaymentMessage();
      return;
    }

    if (angular.isUndefined(this.invoice)) {
      this.$window.scrollTo(0, 0);
      this.actionDispatcher.dispatch(new NoAuthBillInfoAddAction);
      this.notificationService.createInvoiceError();
      return;
    }

    if (this.bill === 'create') {
      this.invoice.address = {};
      if (!this.invoice.firstName || !this.invoice.lastName || !this.invoice.email) {
        this.$window.scrollTo(0, 0);
        this.actionDispatcher.dispatch(new NoAuthBillInfoAddAction);
        this.notificationService.createInvoiceError();
        return;
      }
      this.invoice.firstName = UtilService.decodeHtmlCharCodes(this.$sanitize(this.invoice.firstName));
      this.invoice.lastName = UtilService.decodeHtmlCharCodes(this.$sanitize(this.invoice.lastName));
      this.invoice.email = this.$sanitize(this.invoice.email);
      this.invoice.msisdn = this.$sanitize(this.msisdn);
      this.globalSpinner.startIfNotActivated();
      this.noAuthService.createUpdateInvoiceAddress(this.invoice).then(() => {
        this.actionDispatcher.dispatch(new NoAuthBillInfoChangeAction(this.invoice));
        this.completePayment();
      }).catch((e) => {
        this.globalSpinner.stop();
      });
    } else {
      this.completePayment();
    }
  }

  private completePayment() {
    this.mixpanelService.track('Payment Info Submitted');

    if (this.selectedMethod === 'creditCard') {
      if (!this.approveSaveCard) {
        this.notificationService.showCreditCardSaveNotSelectedMessage();
        return;
      } else {
        this.startPayment(true);
      }
    } else if (this.selectedMethod.indexOf('savedCard') >= 0) {
      if (this.activeCard.showEulaId) {
        this.actionDispatcher.dispatch(
          new OpenCardAddContractAction(() => this.onAcceptContract())
        );
        return; // updated eulaId
      } else {
        //check threeDSecure
        this.check3DSecureForExistingCard();
      }
    } else if (this.selectedMethod.indexOf('savedMasterCard') >= 0) {
      this.globalSpinner.startIfNotActivated();
      this.initiateRecurringPayment(MasterpassOTPTypes.RECURING_PAYMENT, this.activeMasterCard.Name);
    } else if (this.selectedMethod === 'bill') {
      this.actionDispatcher.dispatch(new PayByBillAction());
    }
  }

  public changePaymentMethod() {
    if (!this.invoice) {
      this.$window.scrollTo(0, 0);
      this.actionDispatcher.dispatch(new NoAuthBillInfoAddAction);
      this.notificationService.createInvoiceError();
      return;
    }

    if (this.selectedMethod === 'creditCard' && !this.approveSaveCard) {
      this.notificationService.showCreditCardSaveNotSelectedMessage();
      return;
    }

    let openPopupChangePayment = false;
    if (this.subscription && this.subscription.type == ListeningPackageType.CREDITCARD) {
      if (this.selectedMethod === 'creditCard') {
        openPopupChangePayment = true;
      } else if (this.activeCard && this.activeCard.threeDSecureCreated === 'false') {
        openPopupChangePayment = true;
      }
    }
    if (this.bill === 'create') {
      this.invoice.address = {};
      if (!this.invoice.firstName || !this.invoice.lastName || !this.invoice.email) {
        this.$window.scrollTo(0, 0);
        this.actionDispatcher.dispatch(new NoAuthBillInfoAddAction);
        this.notificationService.createInvoiceError();
        return;
      }
      this.invoice.firstName = UtilService.decodeHtmlCharCodes(this.$sanitize(this.invoice.firstName));
      this.invoice.lastName = UtilService.decodeHtmlCharCodes(this.$sanitize(this.invoice.lastName));
      this.invoice.email = this.$sanitize(this.invoice.email);
      this.invoice.msisdn = this.$sanitize(this.msisdn);
      this.globalSpinner.startIfNotActivated();
      this.noAuthService.createUpdateInvoiceAddress(this.invoice).then(() => {
        this.actionDispatcher.dispatch(new NoAuthBillInfoChangeAction(this.invoice));
        if (openPopupChangePayment) {
          this.actionDispatcher.dispatch(
            new ChangePaymentInfoAction(() => this.onChangePaymentMethodApprove())
          );
        } else {
          this.onChangePaymentMethodApprove()
        }
      }).catch((e) => {
        this.globalSpinner.stop();
      });
    } else {
      if (openPopupChangePayment) {
        this.actionDispatcher.dispatch(
          new ChangePaymentInfoAction(() => this.onChangePaymentMethodApprove())
        );
      } else {
        this.onChangePaymentMethodApprove()
      }
    }

  }

  private onChangePaymentMethodApprove() {
    this.globalSpinner.startIfNotActivated();
    if (this.selectedMethod === 'creditCard') {
      this.onAddCard();
    } else if (this.selectedMethod.indexOf('savedCard') > -1) {
      if (this.activeCard.showEulaId) {
        this.actionDispatcher.dispatch(
          new OpenCardAddContractAction(() => this.onAcceptContract())
        );
        return; // updated eulaId
      } else {
        //check threeDSecure
        this.check3DSecureForExistingCard();
      }
    } else if (this.selectedMethod.indexOf('savedMasterCard') > -1) {
      this.initiateRecurringPayment(MasterpassOTPTypes.RECURING_PAYMENT, this.activeMasterCard.Name);
    }
  }

  private check3DSecureForExistingCard() {
    if (this.cardx || this.payment || (this.subscription && (this.subscription.type === ListeningPackageType.SDP || this.subscription.type === ListeningPackageType.MOBILODEME))) {
      // cardx means that start to changing payment method
      if (this.activeCard.threeDSecureCreated === 'false') {
        // start to firstly update activeCard as secure and than updateSubscription in manage-subscription.controller
        this.updateThreeDSecureBeforeChangePayment();
      }
    } else {
      if (this.activeCard.threeDSecureCreated === 'false') {
        this.updateThreeDSecure();
      } else {
        this.startPayment();
      }

    }
  }

  private updateThreeDSecureBeforeChangePayment() {
    this.noAuthService.get3DSessionIDForUpdate(this.msisdn, '', this.activeCard.paymentMethodID, this.activeCard.cardId).then(data => {
      let sessionId = data;
      this.noAuthService.get3DSessionResult(this.msisdn, sessionId).then(data => {
        const redirectUrl = window.location.href;
        this.paycellService
          .threeDSecure(sessionId, encodeURIComponent(redirectUrl))
          .then(data => {
            localStorage.setItem('updatePaymentMethod', "1");
            localStorage.setItem('cardSessionId', sessionId);
            localStorage.setItem('pmId', '' + this.activeCard.paymentMethodID);
            localStorage.setItem('cardId', '' + this.activeCard.cardId);
            localStorage.setItem('subscriptionId', this.subscription.id)
            document.open();
            document.write(data);
            document.close();
          })
      });
    })
  }

  private updateThreeDSecure() {
    this.noAuthService.get3DSessionIDForUpdate(this.msisdn, this.packet.id, this.activeCard.paymentMethodID, this.activeCard.cardId).then(data => {
      let sessionId = data;
      this.noAuthService.get3DSessionResult(this.msisdn, sessionId).then(data => {
        const redirectUrl = window.location.href;
        this.paycellService
          .threeDSecure(sessionId, encodeURIComponent(redirectUrl))
          .then(data => {
            localStorage.setItem('updatePaymentMethod', "1");
            localStorage.setItem('cardSessionId', sessionId);
            localStorage.setItem('pmId', '' + this.activeCard.paymentMethodID);
            localStorage.setItem('cardId', '' + this.activeCard.cardId);
            document.open();
            document.write(data);
            document.close();
          })
      });

    })
  }

  private onAcceptContract() {
    this.globalSpinner.startIfNotActivated();
    this.noAuthService
      .updatePaymentMethod(this.msisdn, this.activeCard.paymentMethodID, null, this.activeCard.cardId)
      .then(() => {
        this.check3DSecureForExistingCard();
      })
      .catch(error => {
        console.log('eulaId not updated');
      })
      .finally(() => this.globalSpinner.stop());
  }

  private comparator(element: any): boolean {
    return element.isDefault == true;
  }

  public isTurkcellSubscriber(): boolean {
    if (!this.tcellSubscriberCalled) {
      this.noAuthService.isTurkcellSubscriber(this.msisdn).then((result) => {
        this.tcellSubscriber = result;
        this.tcellSubscriberCalled = true;
      });
    }
    return this.tcellSubscriber;
  }

  public checkShowBillStatus() {
    return this.packet.billStatus && this.isTurkcellSubscriber() && !this.payment;
  }

  public checkMobileContractStatus() {
    this.noAuthService.getSubscriptionAvailability(this.msisdn).then((resp) => {
      this.mobileContractDto = resp;
      if (this.mobileContractDto.showContract) {
        this.showEula();
      }
    }).catch(error => {
      console.log('getSubscriptionAvailabilty has error');
    }).finally(() => this.globalSpinner.stop());
  }

  public isValidMethod() {
    if (this.selectedMethod === 'bill' || this.selectedMethod.indexOf('savedCard') >= 0 || this.selectedMethod.indexOf('savedMasterCard') >= 0) {
      this.isinValid = false;
    } else {
      this.isinValid = true;
    }
  }

  private showEula() {
    this.globalSpinner.startIfNotActivated();
    this.noAuthService.getEulaUrl(this.msisdn).then(resp => {
      var httpPattern = /(\<a([^>]*?)(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
      resp.eulaTextUrl = resp.eulaTextUrl.replace(httpPattern, '$1?openInExternalBrowser=true" target="_blank');
      var mailPattern = /((mailto):[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
      resp.eulaTextUrl = resp.eulaTextUrl.replace(mailPattern, 'javascript:void(0)');

      this.eulaTextUrl = this.$sce.trustAsHtml(resp.eulaTextUrl);
    }).catch(error => {
      console.log('eulaModel not found');
    }).finally(() => this.globalSpinner.stop());
  }

  public checkMasterPass() {
    this.noAuthService.isMasterpassV2().then(isV2 => {
      if (isV2) {
        this.checkMasterPassV2();
        return;
      }

      this.checkMasterPassV1();
    }).catch(error => {
      console.log('Error checking masterpass version, trying V2:', error);
      this.checkMasterPassV2();
    });
  }

  private checkMasterPassV1() {
    if (this.cardType === 'paycell') {
      return;
    }
    this.referenceNo = UtilService.generateRandomNumber(999999999999);
    $('[name=referenceNo]').val(this.referenceNo);
    $('[name=userId]').val(this.msisdnTr);
    $('[name=sendSmsLanguage]').val(this.i18n.getCurrentLanguage() == 'en' ? 'eng' : 'tur');
    const masterToken = UtilService.getSessionStorageWithExpire("masterpass.token");
    if (!!masterToken) {
      $('[name=token]').val(masterToken);
      window['MFS'].checkMasterPass($('#checkMP-form'), this.chkMPResponseHandler.bind(this));
    } else {
      this.noAuthService.getToken(this.msisdn).then(token => {
        UtilService.setSessionStorageWithExpire("masterpass.token", token, 840000);
        $('[name=token]').val(token);
        window['MFS'].checkMasterPass($('#checkMP-form'), this.chkMPResponseHandler.bind(this));
      });
    }
  }

  public addMasterpassCard() {
    this.noAuthService.isMasterpassV2().then(isV2 => {
      if (isV2) {
        this.addMasterpassCardV2();
        return;
      }

      this.addMasterpassCardV1();
    }).catch(error => {
      console.log('Error checking masterpass version, trying V2:', error);
      this.addMasterpassCardV2();
    });
  }

  private addMasterpassCardV1() {
    this.otpStatus = MasterpassOTPTypes.ADD_CARD;
    this.globalSpinner.startIfNotActivated();
    this.referenceNo = UtilService.generateRandomNumber(999999999999);
    this.card.ccNo = this.$sanitize(this.card.ccNo);
    this.card.cvcNo = this.$sanitize(this.card.cvcNo);
    this.card.alias = UtilService.decodeHtmlCharCodes(this.$sanitize(this.card.alias));
    this.card.expDateMonth = this.$sanitize(this.card.expDateMonth);
    this.card.expDateYear = this.$sanitize(this.card.expDateYear);
    this.card.ccNo = this.card.ccNo.replace(/-/gi, '');
    $('[name=referenceNo]').val(this.referenceNo);
    $('[name=msisdn]').val(this.msisdnTr);
    $('[name=accountAliasName]').val(this.card.alias);
    $('[name=rtaPan]').val(this.card.ccNo);
    $('[name=expiryDate]').val((this.card.expDateYear + '' + this.card.expDateMonth));
    $('[name=cvc]').val(this.card.cvcNo);
    $('[name=sendSmsLanguage]').val(this.i18n.getCurrentLanguage() == 'en' ? 'eng' : 'tur');
    const masterToken = UtilService.getSessionStorageWithExpire("masterpass.token");
    if (!!masterToken) {
      $('[name=token]').val(masterToken);
      window['MFS'].register($('#register-form'), this.mfsResponseHandler.bind(this));
    } else {
      this.noAuthService.getToken(this.msisdn).then(token => {
        UtilService.setSessionStorageWithExpire("masterpass.token", token, 840000);
        $('[name=token]').val(token);
        window['MFS'].register($('#register-form'), this.mfsResponseHandler.bind(this));
      }).finally(() => this.globalSpinner.stop());
    }
  }

  public listMasterCards() {
    this.noAuthService.isMasterpassV2().then(isV2 => {
      if (isV2) {
        this.listMasterCardsV2();
        return;
      }

      this.listMasterCardsV1();
    }).catch(error => {
      console.log('Error checking masterpass version, trying V2:', error);
      this.listMasterCardsV2();
    });
  }

  private listMasterCardsV1() {
    const masterToken = UtilService.getSessionStorageWithExpire("masterpass.token");
    if (!!masterToken) {
      window['MFS'].listCards(this.msisdnTr, masterToken, this.listCardsResponseHandler.bind(this));
    } else {
      this.noAuthService.getToken(this.msisdn).then(token => {
        UtilService.setSessionStorageWithExpire("masterpass.token", token, 840000);
        window['MFS'].listCards(this.msisdnTr, token, this.listCardsResponseHandler.bind(this));
      }).finally(() => this.globalSpinner.stop());
    }
  }

  private listCardsResponseHandler(statusCode, response) {
    if (response.responseCode != "0000" && response.responseCode != "") {
      console.log(response.responseDescription);
      return;
    }

    this.masterCards = response.cards;
    if (this.mastercardx) {
      this.masterCards = this.masterCards.filter(card => this.mastercardx.Name !== card.Name);
      if (this.masterCards.length > 0) {
        this.activeMasterCard = this.masterCards[0];
      }
    } else {
      this.activeMasterCard = this.masterCards[0];
    }

    if (this.otpStatus != MasterpassOTPTypes.LINK_CARD) {
      this.definePaymentSection();
    }
    this.globalSpinner.stop();
    this.$timeout(() => {});
  }

  private chkMPResponseHandler(status, response) {
    if (response.responseCode == "0000" || response.responseCode == "") {
      if (response.accountStatus.indexOf("000000") == 0) {
        if (this.cards.length) {
          this.selectedMethod = 'masterPassAddCard';
          this.isValidMethod();
        }
      } else if (response.accountStatus.indexOf("011000") == 0) {
        this.selectedMethod = 'masterPassLinkCard';
        this.isValidMethod();
        this.linkCardMode = true;
        this.$translate('payment.masterpass.continue.linkedCard', this.invoice).then(value => {
          this.continueLinkCardMessage = value;
        });
      } else if (response.accountStatus.indexOf("011100") == 0) {
        this.selectedMethod = 'savedMasterCard';
        this.listMasterCards();
      }
    } else if (this.config.masterpass.tokenRefreshErrorCodes.indexOf(response.responseCode) >= 0 && this.masterTokenRefreshCount < 5) {
      sessionStorage.removeItem("masterpass.token");
      this.checkMasterPass();
      this.masterTokenRefreshCount++;
    } else {
      console.log(response.responseDescription);
    }
  }

  private addMasterpassCardV2() {
    this.otpStatus = MasterpassOTPTypes.ADD_CARD;
    this.globalSpinner.startIfNotActivated();
    this.referenceNo = UtilService.generateRandomNumber(999999999999);
    this.card.ccNo = this.$sanitize(this.card.ccNo);
    this.card.cvcNo = this.$sanitize(this.card.cvcNo);
    this.card.alias = UtilService.decodeHtmlCharCodes(this.$sanitize(this.card.alias));
    this.card.expDateMonth = this.$sanitize(this.card.expDateMonth);
    this.card.expDateYear = this.$sanitize(this.card.expDateYear);
    this.card.ccNo = this.card.ccNo.replace(/-/gi, '');

    this.noAuthService.masterpassAddCard(this.msisdn, {
      requestReferenceNumber: this.referenceNo.toString(),
      accountKey: this.msisdnTr,
      accountKeyType: 'Msisdn',
      cardNumber: this.card.ccNo,
      cardHolderName: this.card.ccName,
      expiryDate: this.card.expDateYear + '' + this.card.expDateMonth,
      cvv: this.card.cvcNo,
      accountAliasName: this.card.alias,
      userId: this.msisdnTr,
      isMsisdnValidatedByMerchant: false,
      authenticationMethod: ''
    }).then(response => this.addCardV2ResponseHandler(response))
      .catch(error => this.addCardV2ResponseHandler(error));
  }

  private addCardV2ResponseHandler(response: any) {
    const exceptionCode = response && response.exception ? response.exception.code : null;
    if (exceptionCode === 'AUTHENTICATION_FAILED' || exceptionCode === 'TOKEN_HAS_EXPIRED' || exceptionCode === 'TOKEN_IS_NOT_VALID') {
      this.globalSpinner.stop();
      return;
    }
    const responseCode = this.getV2MasterpassResponseCode(response);
    const responseDescription = this.getV2MasterpassResponseDescription(response);

    if (!responseCode && responseDescription && exceptionCode !== 'SDK_ERROR') {
      this.actionDispatcher.dispatch(new MasterPassError('', responseDescription));
      this.globalSpinner.stop();
      return;
    }

    this.mfsResponseHandler(null, {
      responseCode: responseCode || '',
      responseDescription: responseDescription
    });
  }

  private getV2MasterpassResponseCode(response: any): string {
    if (!response) {
      return null;
    }

    if (response.responseCode) {
      return response.responseCode;
    }

    if (response.result && response.result.responseCode) {
      return response.result.responseCode;
    }

    if (response.exception && response.exception.code) {
      return response.exception.code;
    }

    if (response.data && response.data.exception && response.data.exception.code) {
      return response.data.exception.code;
    }

    return null;
  }

  private getV2MasterpassResponseDescription(response: any): string {
    if (!response) {
      return null;
    }

    if (response.responseDescription) {
      return response.responseDescription;
    }

    if (response.result && response.result.responseDescription) {
      return response.result.responseDescription;
    }

    if (response.exception && response.exception.message) {
      return response.exception.message;
    }

    if (response.data && response.data.exception && response.data.exception.message) {
      return response.data.exception.message;
    }

    if (response.message) {
      return response.message;
    }

    return null;
  }

  private listMasterCardsV2() {
    this.noAuthService.masterpassAccountAccess(this.msisdn, this.msisdnTr)
      .then(response => this.accountAccessResponseHandler(response))
      .catch(error => this.accountAccessResponseHandler(error));
  }

  private checkMasterPassV2() {
    if (this.cardType === 'paycell') {
      return;
    }

    this.noAuthService.masterpassAccountAccess(this.msisdn, this.msisdnTr)
      .then(response => this.accountAccessResponseHandler(response))
      .catch(error => this.accountAccessResponseHandler(error));
  }

  private accountAccessResponseHandler(response: any) {
    const exceptionCode = response && response.exception ? response.exception.code : null;
    if (exceptionCode === 'ACCOUNT_NOT_FOUND') {
      this.listCardsResponseHandler(null, {
        responseCode: '',
        cards: []
      });
      return;
    }

    if (exceptionCode === 'ACCOUNT_NOT_LINKED_TO_MERCHANT') {
      this.chkMPResponseHandler(null, {
        responseCode: '',
        accountStatus: '011000'
      });
      return;
    }

    if (response && response.result) {
      if (response.result.accountInformation && response.result.accountInformation.isAccountLinked === false) {
        this.selectedMethod = 'masterPassLinkCard';
        this.isValidMethod();
        this.linkCardMode = true;
        this.$translate('payment.masterpass.continue.linkedCard', this.invoice).then((value: string) => {
          this.continueLinkCardMessage = value;
        });
        this.definePaymentSection();
        return;
      }

      this.listCardsResponseHandler(null, {
        responseCode: '',
        cards: response.result.cards
      });
      return;
    }

    this.actionDispatcher.dispatch(new MasterPassError(exceptionCode, response && response.exception ? response.exception.message : null));
  }

  private mfsResponseHandler(status, response) {
    if (response.responseCode == "0000" || response.responseCode == "") {
      if (this.otpStatus == MasterpassOTPTypes.ADD_CARD) {
        this.$translate('payment.masterpass.addCard.success.message', this.invoice).then(value => {
          this.notificationService.showNotification({
            text: value,
            type: 'success'
          });
        });

        this.resetAddCardForm();
        this.selectedMethod = 'savedMasterCard0';
        this.$timeout(() => {
          this.listMasterCards();
        }, 500);
        this.globalSpinner.stop();
      } else if (this.otpStatus == MasterpassOTPTypes.LINK_CARD) {
        this.$translate('payment.masterpass.linkedCard.success.message', this.invoice).then(value => {
          this.notificationService.showNotification({
            text: value,
            type: 'success'
          });
        });
        this.resetAddCardForm();
        this.selectedMethod = 'savedMasterCard0';
        this.linkCardMode = false;
        this.listMasterCards();
        this.isValidMethod();
        this.globalSpinner.stop();
      } else if (this.otpStatus == MasterpassOTPTypes.RECURING_PAYMENT) {
        this.actionDispatcher.dispatch(
          new NoAuthPayByMasterpassAction(this.msisdn, this.packet, this.activeMasterCard, this.promocode, () => this.initiateRecurringPayment(MasterpassOTPTypes.DERECURING_PAYMENT, this.activeMasterCard.Name))
        );
      }
    } else {
      if (response.responseCode == "5001" || response.responseCode == "5008") {
        this.actionDispatcher.dispatch(new OpenMasterpassCardAddOtpAction((smsCode, stopTimer, stopReqSent) => this.approveOtp(smsCode, stopTimer, stopReqSent), () => this.onResend(), this.otpStatus));
        this.globalSpinner.stop();
      } else {
        if (response.responseCode == "4152" && this.otpStatus == MasterpassOTPTypes.RECURING_PAYMENT) { // already has recurring pass direct payment
          this.callAAfterD = true;
          this.globalSpinner.startIfNotActivated();
          this.initiateRecurringPayment(MasterpassOTPTypes.DERECURING_PAYMENT, this.activeMasterCard.Name);
        } else {
          if (this.config.masterpass.tokenRefreshErrorCodes.indexOf(response.responseCode) >= 0) {
            sessionStorage.removeItem("masterpass.token");
          }
          this.actionDispatcher.dispatch(new MasterPassError(response.responseCode, response.responseDescription));
          this.globalSpinner.stop();
        }
      }
    }

    if (response.responseCode != "5001" && response.responseCode != "5008") {
      if (response.responseCode != "1409" && !!this.onStopTimer) {
        this.onStopTimer();
        this.onStopTimer = null;
      }
      if (!!this.stopOtpReqSent) {
        this.stopOtpReqSent();
        this.stopOtpReqSent = null;
      }
    }
  }

  private recuringDeactivationRH(status, response) {
    if (response.responseCode == "0000" || response.responseCode == "") {
      if (this.callAAfterD) {
        this.callAAfterD = false;
        this.globalSpinner.startIfNotActivated();
        this.initiateRecurringPayment(MasterpassOTPTypes.RECURING_PAYMENT, this.activeMasterCard.Name);
      }
    }
    this.globalSpinner.stop();
  }

  private approveOtp(smsCode: string, stopTimer: any, stopReqSent: any) {
    this.noAuthService.isMasterpassV2().then(isV2 => {
      if (isV2) {
        this.approveOtpV2(smsCode, stopTimer, stopReqSent);
        return;
      }

      this.approveOtpV1(smsCode, stopTimer, stopReqSent);
    });
  }

  private approveOtpV1(smsCode: string, stopTimer: any, stopReqSent: any) {
    this.globalSpinner.startIfNotActivated();
    this.referenceNo = UtilService.generateRandomNumber(999999999999);
    $('[name=referenceNo]').val(this.referenceNo);
    $('[name=validationCode]').val(smsCode);
    $('[name=sendSmsLanguage]').val(this.i18n.getCurrentLanguage() == 'en' ? 'eng' : 'tur');
    this.onStopTimer = stopTimer;
    this.stopOtpReqSent = stopReqSent;
    window['MFS'].validateTransaction($('#otp-form'), this.mfsResponseHandler.bind(this));
  }

  private approveOtpV2(smsCode: string, stopTimer: any, stopReqSent: any) {
    this.globalSpinner.startIfNotActivated();
    this.onStopTimer = stopTimer;
    this.stopOtpReqSent = stopReqSent;
    this.noAuthService.masterpassVerifyOtp(this.msisdn, smsCode)
      .then(response => this.verifyOtpV2ResponseHandler(response))
      .catch(error => this.verifyOtpV2ResponseHandler(error));
  }

  private verifyOtpV2ResponseHandler(response: any) {
    const responseCode = this.getV2MasterpassResponseCode(response);
    if (responseCode === '0000' || responseCode === '') {
      setTimeout(() => {
        this.mfsResponseHandler(null, {
          responseCode: responseCode || '',
          responseDescription: response && response.exception ? response.exception.message : null
        });
      }, 1000);
    } else {
      this.mfsResponseHandler(null, {
        responseCode: responseCode || '',
        responseDescription: response && response.exception ? response.exception.message : null
      });
    }
  }

  private onResend() {
    this.noAuthService.isMasterpassV2().then(isV2 => {
      if (isV2) {
        this.onResendV2();
        return;
      }

      this.onResendV1();
    }).catch(error => {
      console.log('Error checking masterpass version, trying V2:', error);
      this.onResendV2();
    });
  }

  private onResendV1() {
    var token = window['MFS'].getLastToken();
    var lang = "eng";
    this.onStopTimer = null;
    this.stopOtpReqSent = null;
    window['MFS'].resendOtp(token, lang, this.mfsResponseHandler.bind(this));
  }

  private onResendV2() {
    this.onStopTimer = null;
    this.stopOtpReqSent = null;
    this.noAuthService.masterpassResendOtp(this.msisdn)
      .then(response => this.resendOtpV2ResponseHandler(response))
      .catch(error => this.resendOtpV2ResponseHandler(error));
  }

  private resendOtpV2ResponseHandler(response: any) {
    const responseCode = this.getV2MasterpassResponseCode(response);
    this.mfsResponseHandler(null, {
      responseCode: responseCode || '',
      responseDescription: response && response.exception ? response.exception.message : null
    });
  }

  public checkLinkMasterpassModal() {
    if (this.linkCardMode) {
      if (this.masterCards.length > 0) {
        this.selectedMethod = 'savedMasterCard0';
      } else {
        this.selectedMethod = 'masterPassLinkCard';
      }
      this.actionDispatcher.dispatch(new OpenMasterpassCardLinkAction(() => this.linkMasterpassCard()));
    } else {
      this.selectedMethod = 'masterPassAddCard';
    }
    this.isValidMethod();
  }

  public listLinkedAccount() {
    if (this.linkCardMode) {
      this.linkMasterpassCard();
      return;
    }
    this.resetAddCardForm();
    this.selectedMethod = 'savedMasterCard0';
    this.listMasterCards();
    this.isValidMethod();
  }

  public linkMasterpassCard() {
    this.noAuthService.isMasterpassV2().then(isV2 => {
      if (isV2) {
        this.linkMasterpassCardV2();
        return;
      }

      this.linkMasterpassCardV1();
    }).catch(error => {
      console.log('Error checking masterpass version, trying V2:', error);
      this.linkMasterpassCardV2();
    });
  }

  private linkMasterpassCardV1() {
    this.otpStatus = MasterpassOTPTypes.LINK_CARD;
    $('[name=referenceNo]').val(this.referenceNo);
    $('[name=msisdn]').val(this.msisdnTr);
    $('[name=sendSmsLanguage]').val(this.i18n.getCurrentLanguage() == 'en' ? 'eng' : 'tur');
    const masterToken = UtilService.getSessionStorageWithExpire("masterpass.token");
    if (!!masterToken) {
      $('[name=token]').val(masterToken);
      window['MFS'].linkCardToClient($('#linkCardtoMP-form'), this.mfsResponseHandler.bind(this));
    } else {
      this.noAuthService.getToken(this.msisdn).then(token => {
        UtilService.setSessionStorageWithExpire("masterpass.token", token, 840000);
        $('[name=token]').val(token);
        window['MFS'].linkCardToClient($('#linkCardtoMP-form'), this.mfsResponseHandler.bind(this));
      }).finally(() => this.globalSpinner.stop());
    }
  }

  private linkMasterpassCardV2() {
    this.otpStatus = MasterpassOTPTypes.LINK_CARD;
    this.noAuthService.masterpassLinkToMerchant(this.msisdn, this.msisdnTr)
      .then(response => this.linkToMerchantV2ResponseHandler(response))
      .catch(error => this.linkToMerchantV2ResponseHandler(error));
  }

  private linkToMerchantV2ResponseHandler(response: any) {
    const exceptionCode = response && response.exception ? response.exception.code : null;
    if (exceptionCode === 'AUTHENTICATION_FAILED' || exceptionCode === 'TOKEN_HAS_EXPIRED' || exceptionCode === 'TOKEN_IS_NOT_VALID') {
      this.globalSpinner.stop();
      return;
    }
    const responseCode = this.getV2MasterpassResponseCode(response);
    this.mfsResponseHandler(null, {
      responseCode: responseCode || '',
      responseDescription: response && response.exception ? response.exception.message : null
    });
  }

  public initiateRecurringPayment(actionType: MasterpassOTPTypes, masterCardName) {
    if (this.packet.type == ListeningPackageType.MOBILODEME && (this.mastercardx || this.payment)) {
      this.noAuthService.getRelatedCC(this.msisdn, this.packet.id)
        .then(listeningPackage => {
          this.recurringPayment(actionType, masterCardName, listeningPackage.priceDescription, listeningPackage.price, listeningPackage.sardisOfferId);
        });
    } else {
      this.recurringPayment(actionType, masterCardName, this.packet.priceDescription, this.packet.price, this.packet.sardisOfferId);
    }

  }

  private recurringPayment(actionType: MasterpassOTPTypes, masterCardName, priceDetails: any, price: any, sardisOfferId: string) {
    this.noAuthService.isMasterpassV2().then(isV2 => {
      if (isV2) {
        this.recurringPaymentV2(actionType, masterCardName, priceDetails, price, sardisOfferId);
        return;
      }

      this.recurringPaymentV1(actionType, masterCardName, priceDetails, price, sardisOfferId);
    }).catch(error => {
      console.log('Error checking masterpass version, trying V2:', error);
      this.recurringPaymentV2(actionType, masterCardName, priceDetails, price, sardisOfferId);
    });
  }

  private recurringPaymentV1(actionType: MasterpassOTPTypes, masterCardName, priceDetails: any, price: any, sardisOfferId: string) {
    this.otpStatus = actionType;
    $('[name=referenceNo]').val(this.referenceNo);
    $('[name=msisdn]').val(this.msisdnTr);
    $('[name=sendSmsLanguage]').val(this.i18n.getCurrentLanguage() == 'en' ? 'eng' : 'tur');
    try {
      if (priceDetails) {
        var priceDetails = JSON.parse(priceDetails);
        if (priceDetails.laterPrice)
          price = parseFloat(priceDetails.laterPrice.replace(',', '.'));
      }
    } catch (error) { }
    $('[name=amount]').val((price * 100 * 10).toFixed());
    $('[name=actionType]').val(this.otpStatus == MasterpassOTPTypes.RECURING_PAYMENT ? 'A' : 'D');
    var fiveYearsFromNow = new Date();
    fiveYearsFromNow.setFullYear(fiveYearsFromNow.getFullYear() + 5);
    var month = (fiveYearsFromNow.getMonth() + 1).toString();
    var day = (fiveYearsFromNow.getDate()).toString();
    $('[name=endDate]').val(fiveYearsFromNow.getFullYear() + '' + (month.length == 1 ? '0' + month : month) + '' + (day.length == 1 ? '0' + day : day));
    $('[name=listAccountName]').val(masterCardName);
    $('[name=productId]').val(sardisOfferId);
    const masterToken = UtilService.getSessionStorageWithExpire("masterpass.token");
    if (!!masterToken) {
      $('[name=token]').val(masterToken);
      window['MFS'].initiateRecurringPayment($('#recurringPayment-form'),
        this.otpStatus == MasterpassOTPTypes.RECURING_PAYMENT ? this.mfsResponseHandler.bind(this) : this.recuringDeactivationRH.bind(this));
    } else {
      this.noAuthService.getToken(this.msisdn).then(token => {
        UtilService.setSessionStorageWithExpire("masterpass.token", token, 840000);
        $('[name=token]').val(token);
        window['MFS'].initiateRecurringPayment($('#recurringPayment-form'),
          this.otpStatus == MasterpassOTPTypes.RECURING_PAYMENT ? this.mfsResponseHandler.bind(this) : this.recuringDeactivationRH.bind(this));
      }).finally(() => this.globalSpinner.stop());
    }
  }

  private recurringPaymentV2(actionType: MasterpassOTPTypes, masterCardName, priceDetails: any, price: any, sardisOfferId: string) {
    if (actionType !== MasterpassOTPTypes.RECURING_PAYMENT) {
      this.recurringOrderDeleteV2(masterCardName, sardisOfferId);
      return;
    }

    this.otpStatus = actionType;
    try {
      if (priceDetails) {
        var parsedPriceDetails = JSON.parse(priceDetails);
        if (parsedPriceDetails.laterPrice)
          price = parseFloat(parsedPriceDetails.laterPrice.replace(',', '.'));
      }
    } catch (error) { }

    var fiveYearsFromNow = new Date();
    fiveYearsFromNow.setFullYear(fiveYearsFromNow.getFullYear() + 5);
    var month = (fiveYearsFromNow.getMonth() + 1).toString();
    var day = (fiveYearsFromNow.getDate()).toString();
    var expireDate = fiveYearsFromNow.getFullYear() + '' + (month.length == 1 ? '0' + month : month) + '' + (day.length == 1 ? '0' + day : day);

    const request = {
      accountKey: this.msisdnTr,
      cardAlias: masterCardName,
      productId: sardisOfferId,
      amountLimit: (price * 100 * 10).toFixed(),
      expireDate: expireDate,
      authenticationMethod: '',
      requestReferenceNumber: this.referenceNo ? this.referenceNo.toString() : UtilService.generateRandomNumber(999999999999).toString()
    };

    this.executeRecurringOrderV2(request);
  }

  private executeRecurringOrderV2(request: any, isRetry: boolean = false) {
    this.noAuthService.masterpassRecurringOrder(this.msisdn, request)
      .then(response => this.recurringOrderV2ResponseHandler(response, request, isRetry))
      .catch(error => this.recurringOrderV2ResponseHandler(error, request, isRetry));
  }

  private recurringOrderV2ResponseHandler(response: any, request?: any, isRetry: boolean = false) {
    const responseCode = this.getV2MasterpassResponseCode(response);

    if (responseCode === 'RECURRING_PAYMENT_ORDER_ALREADY_EXISTS' && !!request && !isRetry) {
      this.noAuthService.masterpassRecurringOrderDelete(this.msisdn, {
        accountChangedEventName: '',
        accountKey: request.accountKey,
        authenticationMethod: '',
        cardAlias: request.cardAlias,
        productId: request.productId,
        requestReferenceNumber: request.requestReferenceNumber
      }).then(() => this.executeRecurringOrderV2(request, true))
        .catch(() => this.executeRecurringOrderV2(request, true));
      return;
    }

    this.mfsResponseHandler(null, {
      responseCode: responseCode || '',
      responseDescription: response && response.exception ? response.exception.message : null
    });
  }

  private recurringOrderDeleteV2(masterCardName: string, sardisOfferId: string) {
    this.otpStatus = MasterpassOTPTypes.DERECURING_PAYMENT;
    this.noAuthService.masterpassRecurringOrderDelete(this.msisdn, {
      accountChangedEventName: '',
      accountKey: this.msisdnTr,
      authenticationMethod: '',
      cardAlias: masterCardName,
      productId: sardisOfferId,
      requestReferenceNumber: this.referenceNo ? this.referenceNo.toString() : UtilService.generateRandomNumber(999999999999).toString()
    }).then(response => this.recurringOrderDeleteV2ResponseHandler(response))
      .catch(error => this.recurringOrderDeleteV2ResponseHandler(error));
  }

  private recurringOrderDeleteV2ResponseHandler(response: any) {
    const responseCode = this.getV2MasterpassResponseCode(response);
    this.recuringDeactivationRH(null, {
      responseCode: responseCode || '',
      responseDescription: response && response.exception ? response.exception.message : null
    });
  }

  public openInfoModal() {
    this.actionDispatcher.dispatch(new OpenMasterpassInfoAction());
  }

  public clickUnModeledRadio(targetMethod: string) {
    this.selectedMethod = targetMethod;
    this.isValidMethod();
  }

  public resetAddCardForm() {
    this.card = null;
    this.showCardSaveForm = false;
    if (this.cardAddForm) {
      this.cardAddForm.$setPristine();
      this.cardAddForm.$setUntouched();
    }
  }

  public getMasterPassCardLogoonError(card: MasterCard) {
    return card.Value1.startsWith('4') ? '/assets/img/visa@2x.png' : (card.Value1.startsWith('5') ? '/assets/img/credit-card-logo.png' : '');
  }
}



// WEBPACK FOOTER //
// ./src/app/no-auth/components/payment-method/payment-method.controller.ts